import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_FILTER_BOT_TRACKING_EVENTS = createFcmConfig('filter_bot_tracking_events', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
